// A brand's studio: creation (wizard), setup and collection, competitors,
// personas, audience crossroads, the author directory and drifts.
export default {
  commun: {
    fermer: 'close',
    annuler: 'cancel',
    ajouter: 'Add',
    direct: 'direct',
    aspirationnel: 'aspirational',
    verifie: 'verified',
    aVerifier: 'to check',
    urlCompte: 'Account URL',
    inclusion: 'Inclusion keywords',
    exclusion: 'Exclusion keywords',
    plateforme: 'Platform:',
    toutes: 'All',
    tous: 'All',
    nomConcurrent: 'Competitor name',
    retenus: '{n} kept',
    lancementImpossible: 'Could not start',
    sauvegardeImpossible: 'Could not save',
    suppressionImpossible: 'Could not delete',
    suggestionImpossible: 'Suggestion failed',
    nonSegmente: 'Unsegmented',
    confiance: 'confidence',
    citation: '‘{texte}’',
  },
  plateformes: {
    website: 'Website',
  },
  indicesComptes: {
    youtube: "Channel URL (e.g. https://www.youtube.com/{'@'}inoxtag or /channel/UCxxx).",
    twitch: 'Twitch channel (e.g. https://www.twitch.tv/kamet0).',
    x: 'Profile URL (e.g. https://x.com/inoxtag).',
    instagram: 'Profile URL (e.g. https://www.instagram.com/inoxtag).',
    linkedin: 'Company page or profile (e.g. https://www.linkedin.com/company/orion or /in/jane-doe).',
    tiktok: "Profile URL (e.g. https://www.tiktok.com/{'@'}inoxtag).",
    website: 'Official website (e.g. https://www.kcorp.gg), used by the twins in Arena mode.',
    app_store: 'App Store page (e.g. https://apps.apple.com/fr/app/mon-jeu/id1542776143): public reviews are collected free of charge.',
    google_play: 'Google Play page (e.g. https://play.google.com/store/apps/details?id=com.mon.jeu): public reviews are collected free of charge.',
  },
  indicesPages: {
    instagram: 'Instagram link (post /p/, reel /reel/ or profile).',
    x: 'Link to an X / Twitter status only (https://x.com/.../status/...). Profiles not supported.',
    trustpilot: 'The brand’s Trustpilot review page (https://www.trustpilot.com/review/...).',
    amazon_reviews: "Amazon product URL (https://www.amazon.com/.../dp/{'<'}ASIN{'>'}).",
    youtube_video: 'YouTube video URL (watch?v=... or youtu.be/...).',
    linkedin: 'LinkedIn post URL (linkedin.com/posts/..., /pulse/... or /feed/update/...). Profiles and company pages not supported.',
  },
  wizard: {
    titre: 'New brand',
    sousTitre: '4 steps · the brand is created at the last one, not before',
    etapes: {
      identite: 'Identity',
      comptes: 'Accounts & presence',
      concurrents: 'Competitors',
      recap: 'Summary',
    },
    seuilPermissif: 'permissive: more signals, more noise',
    seuilStrict: 'strict: less noise, risk of missing signals',
    seuilEquilibre: 'balanced',
    attenteCadrage: 'waiting for the framing…',
    comptesProposes: '{n} accounts suggested | {n} account suggested | {n} accounts suggested',
    dejaRenseignees: 'the platforms found are already filled in',
    aucunCompteTrouve: 'no account found with enough certainty: add them by hand',
    marqueCreeEchecs: 'Brand created. Competitors not added: {liste}. Add them from its screen.',
    creationImpossible: 'Could not create',
    nomRequis: 'The brand name is required.',
    dossierHote: 'This will be the brand of the {dossier} project.',
    dossierPris: 'The {dossier} project already has its brand: this one will get its own project, under its name (one brand per project).',
    sansDossier: 'This brand will get its own project, under its name.',
    nomMarque: 'Brand name',
    categorie: 'Category',
    choisir: '- choose -',
    secteur: 'Sector',
    secteurExemple: 'Gaming / entertainment',
    description: 'Description',
    descriptionExemple: 'New shorts IP about French video game heritage.',
    descriptionAide: 'It is used to tell the brand apart from its namesakes: one precise sentence beats a paragraph.',
    langue: 'Language',
    pays: 'Country',
    suggererComptesTitre: 'Orion looks for the brand’s official accounts',
    recherche: 'Searching… {s} s',
    suggestionOrion: 'Orion suggestion',
    detectes: 'Detected from the name and description: check each URL.',
    attenteRecherche: 'Orion is searching the web for the official accounts: around thirty seconds as a rule,',
    plusLong: 'longer than usual; the search restarts automatically if it drags on',
    parfois: 'sometimes more.',
    comptesMarque: 'Brand accounts',
    comptesMarqueAide: 'Its own channels, website included. Their content is collected WITHOUT a filter: by construction, it is about the brand.',
    pages: 'Pages to collect',
    pagesAide: 'Specific pages where people talk about it: a Trustpilot page, an Amazon product, a video. Their content GOES through the disambiguation filter.',
    autres: 'Other presences',
    autresAide: 'Bluesky, a Discord server, a press page… Recorded in the brand’s project, but {pasCollectees}: no connector can read an arbitrary platform.',
    pasCollectees: 'not collected',
    nonCollecte: 'not collected',
    nomPlateforme: 'Platform name',
    suggererConcurrentsTitre: 'Orion analyses the sector and suggests competitors',
    analyseSecteur: 'Analysing the sector…',
    decochez: 'Untick what you do not keep.',
    aucunConcurrent: 'No competitors yet: run the suggestion, or add one by hand.',
    saisi: 'manual',
    sansJustification: 'Suggested without justification: check it before keeping it.',
    urlFacultative: 'URL (optional)',
    vaEtreCree: 'What will be created',
    sansQualification: 'no details',
    nbComptes: 'brand account(s)',
    nbPages: 'page(s) to collect',
    nbConcurrents: 'competitor(s) kept',
    autresNotees: '{n} other presence(s) recorded, not collected.',
    desambiguisation: 'Disambiguation',
    analyseEnCours: 'analysis in progress…',
    detectee: 'detected',
    echecRelancer: 'failed: retry',
    masquer: 'Hide',
    avances: 'Advanced',
    aucuneDesamb: 'No disambiguation: collection will not be able to tell the brand apart from its namesakes.',
    seuleChose: 'This is the only step where a wrong value contaminates ALL downstream scores. Review it.',
    desambExemple: 'What the brand is, and what it is not.',
    alias: 'Aliases',
    aliasExemple: 'another spelling of the name',
    inclusionExemple: 'a signal must contain…',
    exclusionExemple: 'never confuse with…',
    seuil: 'Threshold',
    auditTitre: 'Runs the full audit as soon as the brand is created',
    lancerAudit: 'Run the full audit immediately',
    collecteSources: 'Collection from every source, then the personas, the scores and AI presence.',
    collecteSourcesN: 'Collection from every source ({n} connectors), then the personas, the scores and AI presence.',
    sinon: 'Otherwise, the brand is created and you run the audit from its screen whenever you like.',
    creeTitre: 'Creates the brand',
    creation: 'Creating…',
    creerEtLancer: 'Create the brand and run the audit',
    creer: 'Create the brand',
    precedent: '← Previous',
    suivant: 'Next →',
  },
  config: {
    titre: 'Setup & ingestion',
    sousTitre: '{marque} · pipelines by platform, keywords, sharing',
    niveaux: {
      galaxy: 'Galaxy',
      solar_system: 'Solar system',
      planet: 'Planet',
    },
    changerMarque: 'switch brand with the selector in the sidebar',
    lancerAuditTitre: 'Runs a full audit of the brand, tracked on the Audits page. Collection is skipped automatically if the data is recent.',
    lancement: 'Starting…',
    lancerAudit: 'Run an audit',
    ingestionsEnCours: '{n} ingestions running | {n} ingestion running | {n} ingestions running',
    statuts: {
      done: 'done',
      running: 'running',
      error: 'error',
      cancelled: 'cancelled',
      never: 'never run',
    },
    enCours: 'running…',
    dernierRun: 'last run · {date}',
    collectes: 'collected',
    retenus: 'kept',
    ecartes: 'excluded',
    doublons: 'duplicates',
    vides: '{n} empty',
    videsTitre: 'Collected content that cannot be used (missing text or unexpected format): it never becomes signals.',
    erreursCollecte: '{n} collection errors',
    erreursTitre: 'Collection brought back nothing usable (empty page, no results…). Try again later or adjust the keywords / URLs.',
    lancerTitre: 'Starts collection from this source',
    lancer: 'Run',
    reseaux: 'Networks, websites and official accounts',
    enregistrement: 'saving…',
    enregistrementImpossible: 'Could not save',
    reseauxAide: 'Collection reads them, and the twins use them: the Arena scrolls through the brand’s YouTube channel and visits its official presences.',
    aucunCompte: 'No accounts. App stores count: their reviews are the richest source for an app, and they are free.',
    autre: 'Other',
    verifieTitre: 'Verified: click to flag it for checking',
    proposeTitre: 'Suggested by Orion without confirmation: click to validate',
    retirerCompteTitre: 'Remove this account: its collection stops, the signals already gathered remain',
    ajouterCompteTitre: 'Add an official account',
    ajouterCompte: '+ add an account',
    urlsSuivies: 'Tracked URLs · {n}',
    autresUrls: '+ {n} more…',
    aucuneUrl: 'No tracked URLs.',
    ajouterMotCle: '+ add',
    analyseAuto: 'Automatic analysis',
    cadenceTitre: 'Frequency of automatic audits, run by the backend scheduler',
    cadences: {
      manual: 'Manual (never)',
      daily: 'Daily',
      weekly: 'Weekly',
      biweekly: 'Every 2 weeks',
      monthly: 'Monthly',
    },
    concurrentsLeger: 'Competitors in light mode',
    schedulerAide: 'The scheduler reruns ingestion + analysis at this frequency (requires ENABLE_ORION_V3_SCHEDULER=true on the server).',
    partage: 'Brand sharing',
    emailExemple: "email{'@'}example.com",
    lecteur: 'Viewer',
    editeur: 'Editor',
    partagerTitre: 'Shares the brand with this account',
    inviter: 'Invite',
    invitationImpossible: 'Could not invite',
    retirerPartage: 'Remove this share',
    sur: 'Sure? This cannot be undone.',
    supprimerAide: 'Deleting the brand erases its setup and aggregated scores.',
    supprimerTitre: 'Deletes the brand, its setup and its aggregated scores',
    suppression: 'Deleting…',
    confirmer: 'Confirm',
    supprimer: 'Delete',
    cible: 'target: {cible} · duration {duree}',
  },
  concurrents: {
    titre: 'Competitors',
    auTotal: '{n} in total',
    fixent: 'they set the 4R reference average',
    aucunTrouve: 'No competitor found with enough certainty: add them by hand.',
    detectionImpossible: 'Detection failed',
    ajoutImpossible: 'Could not add',
    basculeImpossible: 'Could not switch',
    changementImpossible: 'Could not change',
    retraitImpossible: 'Could not remove',
    ceConcurrent: 'this competitor',
    confirmerRetrait: 'Remove {nom} permanently?\n\n‘Exclude’ is enough to keep it out of the scores: it stays in the history.',
    concurrentLie: 'linked competitor',
    site: 'website ↗',
    directTitre: 'Direct: it competes for your viewers now. Click to make it aspirational.',
    aspirationnelTitre: 'Aspirational: out of reach today, it serves as a benchmark. Click to make it direct.',
    retenuTitre: 'Kept: it counts in the reference average. Click to exclude it.',
    ecarteTitre: 'Excluded: it does not count in the scores. Click to keep it.',
    retenu: 'kept',
    ecarte: 'excluded',
    suggere: 'suggested',
    retirerTitre: 'Remove permanently: ‘exclude’ is enough to keep it out of the scores',
    aucun: 'No competitors. Without them, the 4R reference average has nothing to compare against.',
    detecterTitre: 'Orion searches the web for competitors and adds them as ‘suggested’: the call is yours',
    detection: 'Detecting… {s} s',
    detecter: 'Detect automatically',
    rechercheEnCours: 'web search in progress, up to three minutes',
    arriventSuggere: 'they arrive as ‘suggested’: it is up to you to keep or exclude them',
    urlExemple: 'website or account (optional)',
    ajouterTitre: 'Adds this competitor: it will count in the reference average',
    ajout: 'adding…',
  },
  personas: {
    titre: 'Talk to the personas',
    sousTitre: 'Talk to your audiences’ personas',
    suggestions: {
      formatCourt: 'What do you think of a new short format on this topic?',
      desabonner: 'What would make you unsubscribe?',
    },
    testImpossible: 'Test failed',
    verdicts: {
      aligned: 'Compatible',
      partial: 'Partial',
      misaligned: 'Tension triggered',
    },
    sourceTitre: 'Personas built from your audience, computed on {date}',
    chargement: 'Loading personas…',
    nonCalculees: 'Personas not computed for this brand: run a full analysis first.',
    part: 'share',
    tropEpars: 'signals too scattered to form a persona',
    nouvelleConversation: 'New conversation',
    posezMoi: 'Ask me a question: I answer with my segment’s vocabulary.',
    ecrireA: 'Write to {nom}…',
    pressureExemple: 'Pressure-test an idea against every persona…',
    analyse: 'Analysing…',
    tester: 'Test',
    reco: 'Reco:',
    confiancePct: 'confidence {n}%',
  },
  carrefours: {
    titre: 'Audience crossroads',
    sousTitre: 'Co-mentions: what your audiences mention in common',
    intro: 'What the audience mentions in common, observed across your audience’s authors.',
    auteursUniques: '{n} unique authors',
    type: 'Type:',
    types: {
      handle: 'account',
      hashtag: 'hashtag',
      proper_noun: 'proper noun',
    },
    agregation: 'Aggregating co-mentions…',
    aucun: 'No crossroads detected: several authors must mention the same entity.',
    mentions: 'mentions',
    auteurs: 'authors',
    couverture: 'coverage',
    mentionsPar: '{m} mentions by {a} distinct authors',
  },
  auteurs: {
    titre: 'Author directory',
    sousTitre: 'The authors behind the current brand’s signals',
    persona: 'Persona:',
    auteursDistincts: '{n} distinct authors',
    topAffiche: 'top {n} shown',
    colAuteur: 'Author',
    colPlateforme: 'Platform',
    colSignaux: 'Signals',
    colSentiment: 'Sentiment',
    colDernier: 'Latest signal',
    trierSignaux: 'Sort by signals',
    trierSentiment: 'Sort by average sentiment',
    agregation: 'Aggregating authors…',
    moyenneSur: 'average over {n} scored signals',
    nonCalcule: 'sentiment not computed',
    aucun: 'No authors: widen the filters or run an ingestion.',
    ouvrezDossier: 'Open a project in the sidebar: the directory belongs to its brand.',
  },
  drifts: {
    sousTitre: 'Drifts detected between two audits · across brands',
    marque: 'Brand:',
    severite: 'Severity:',
    severites: {
      err: 'critical',
      warn: 'moderate',
      ok: 'info',
    },
    analyse: 'Analysing snapshots…',
    aucune: 'No drift: stability is information too.',
    types: {
      retention: 'retention drop',
      resonance: 'resonance drop',
      persona: 'persona drift',
      white_space: 'white space',
    },
    ouvrirAudits: 'Open the audits',
  },
}
